<template>
  <div class="page">
    <div class="header-menu">
      <navBar v-model="objSave"></navBar>
      <div class="messageNotify-tabs">
        <span v-for="NotifyType in NotifyTypes" :class="{'active':NotifyTypeActive==NotifyType.value}" @click="ChangeNotifyType(NotifyType.value)">{{NotifyType.label}}</span>
      </div>
    </div>
    <div class="page-content">
      <div class="messageNotify">
        <div v-if="NotifyTypeActive==1" style="position: relative;">
          <Scroll ref="scroll" :data="UnreadLists" :scrollbar="scrollbarObj" :pullUpLoad="pullUpLoadObj"
            :pullDownRefresh="pullDownRefreshObj" @pullingDown="onPullingDown" :startY="parseInt(startY)" @pullingUp="onPullingUp">
            <div class="messageNotify-wrapper" v-if="flilterUnreadLists.length>0" style="margin-bottom:0.266rem">
              <div class="messageNotify-total">{{$t('system_messagenotify_messagenotify_gong')}}{{flilterUnreadLists.length}}<span>{{$t('system_messagenotify_messagenotify_tiaoxiaoxi')}}</span></div>
              <div class="messageNotify-contents">
                <div class="messageNotify-title">
                  <img src="/static/img/new.png" />
                  <span>{{$t('system_messagenotify_messagenotify_weiduxiaoxi')}}</span>
                </div>
                <div v-for="(NotifyInfoList,index) in flilterUnreadLists">
                  <notifyItem @deletes="deletes(index,NotifyInfoList.NotifyID,'')" :UnreadIDs="UnreadIDs" @skip="skip"
                    :value="NotifyInfoList" :index="index"></notifyItem>
                </div>
              </div>
            </div>
            <div class="messageNotify-wrapper" v-if="flilterLists.length>0">
              <div class="messageNotify-total">{{$t('system_messagenotify_messagenotify_gong')}}{{flilterLists.length}}<span>{{$t('system_messagenotify_messagenotify_tiaoxiaoxi')}}</span></div>
              <div class="messageNotify-contents">
                <div class="messageNotify-title">
                  <img src="/static/img/new.png" />
                  <span>{{$t('system_messagenotify_messagenotify_yiduxiaoxi')}}</span>
                </div>
                <div v-for="(NotifyInfoList,index) in flilterLists">
                  <notifyItem @deletes="deletes(index,NotifyInfoList.NotifyID,'reade')" :UnreadIDs="UnreadIDs" @skip="skip"
                    :value="NotifyInfoList" :index="index"></notifyItem>
                </div>
              </div>
            </div>
            <div class="notifyData" v-if="flilterUnreadLists.length<=0&&flilterLists.length<=0">
              <img src="/static/img/notifyData.png" style="width:100%" />
              <div style="text-align:center;color:#666;font-size:0.425rem;">{{$t('system_messagenotify_messagenotify_zanwuxiaoxi')}}</div>
            </div>
          </Scroll>
        </div>
        <div v-if="NotifyTypeActive==2" style="position: relative;">
          <Scroll ref="scroll" :data="lists" :scrollbar="scrollbarObj" :pullUpLoad="pullUpLoadObj" :pullDownRefresh="pullDownRefreshObj"
            @pullingDown="onPullingDown" :startY="parseInt(startY)" @pullingUp="onPullingUp">
            <div class="messageNotify-wrapper" v-if="lists.length>0" style="margin-bottom:0.266rem">
              <div class="messageNotify-total">{{$t('system_messagenotify_messagenotify_gong')}}{{lists.length}}<span>{{$t('system_messagenotify_messagenotify_tiaoxiaoxi')}}</span></div>
              <div class="messageNotify-contents">
                <div v-for="(list,index) in lists">
                  <notifyItem @skip="skipSystem" @deletes="deletes(index,list.NotifyID)" :value="list" :UnreadIDs="UnreadIDs"
                    :index="index"></notifyItem>
                </div>
              </div>
            </div>
            <div class="notifyData" v-if="lists.length<=0">
              <img src="/static/img/notifyData.png" style="width:100%" />
              <div style="text-align:center;color:#666;font-size:0.425rem;">{{$t('system_messagenotify_messagenotify_zanwuxiaoxi')}}</div>
            </div>
          </Scroll>
        </div>
        <div v-if="NotifyTypeActive==3" style="position: relative;">
          <Scroll ref="scroll" :data="lists" :scrollbar="scrollbarObj" :pullUpLoad="pullUpLoadObj" :pullDownRefresh="pullDownRefreshObj"
            @pullingDown="onPullingDown" :startY="parseInt(startY)" @pullingUp="onPullingUp">
            <div class="messageNotify-wrapper" v-if="lists.length>0" style="margin-bottom:0.266rem">
              <div class="messageNotify-total">{{$t('system_messagenotify_messagenotify_gong')}}{{lists.length}}<span>{{$t('system_messagenotify_messagenotify_tiaoxiaoxi')}}</span></div>
              <div class="messageNotify-contents">
                <div v-for="(list,index) in lists">
                  <notifyItem @deletes="deletes(index,list.NotifyID)" @skip="skipSystem" :UnreadIDs="UnreadIDs" :value="list"
                    :index="index"></notifyItem>
                </div>
              </div>
            </div>
            <div class="notifyData" v-if="lists.length<=0">
              <img src="/static/img/notifyData.png" style="width:100%" />
              <div style="text-align:center;color:#666;font-size:0.425rem;">{{$t('system_messagenotify_messagenotify_zanwuxiaoxi')}}</div>
            </div>
          </Scroll>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
  .header-menu {
    background-color: #12a3ff;
    height: 2.553rem;
  }

  .header-menu~.page-content {
    top: 2.553rem
  }

  .iphoneX .header-menu {
    height: 3.617rem;
  }

  .iphoneX .header-menu~.page-content {
    top: 3.617rem;
  }

  .appInner .header-menu {
    height: 3.085rem;
  }

  .appInner .header-menu~.page-content {
    top: 3.085rem;
  }

  .messageNotify {
    height: 100%;
  }

  .messageNotify>div {
    height: 100%;
  }

  .notifyData {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 3.458rem;
    height: 3.458rem;
    margin-top: -1.729rem;
    margin-left: -1.729rem;
  }

  .messageNotify-tabs {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #fff;
  }

  .messageNotify-tabs>span {
    width: 100%;
    text-align: center;
    display: block;
    height: 1.064rem;
    line-height: 1.064rem;
    font-size: 0.372rem;
    color: #323232
  }

  .messageNotify-tabs .active {
    color: #12a3ff;
    border-bottom: 2px solid #368de8;
    box-sizing: border-box;
  }

  .messageNotify-total {
    font-size: 0.345rem;
    color: #999999;
    background-color: #f0f0f0;
    height: 0.744rem;
    line-height: 0.744rem;
    padding-left: 0.266rem;
  }

  .messageNotify-contents {
    background-color: #fff;
    padding-top: 0.399rem;
  }

  .messageNotify-title {
    color: #999;
    font-size: 0.345rem;
    padding-left: 0.532rem;
  }

  .messageNotify-title img {
    vertical-align: middle;
    width: 0.478rem;
  }

  .messageNotify-title span {
    vertical-align: middle;
    padding-left: 0.266rem;
  }

</style>
<script>
  import Scroll from '../modules/Scroll.vue'
  import BScroll from 'better-scroll'
  import notifyItem from './notifyItem.vue'
  import navBar from '../modules/navBar.vue'
  export default {
    data() {
      return {
        scrollbar: false,
        scrollbarFade: true,
        pullDownRefresh: true,
        pullDownRefreshThreshold: 90,
        pullDownRefreshStop: 40,
        pullUpLoad: true,
        pullUpLoadThreshold: 0,
        pullUpLoadMoreTxt: 'share.pullUpLoadMoreTxt',
        pullUpLoadNoMoreTxt: 'share.pullUpLoadNoMoreTxt',
        startY: 0,
        scrollToX: 0,
        scrollToY: -200,
        scrollToTime: 700,
        scrollToEasing: 'bounce',
        scrollToEasingOptions: ['bounce', 'swipe', 'swipeBounce'],
        objSave: {
          centerTitle: this.$root.$t('system_messagenotify_messagenotify_xiaoxitongzhi') ,
          rightTitle: ''
        },
        NotifyTypes: [{
          label: this.$root.$t('system_messagenotify_messagenotify_quanbuxiaoxi') ,
          value: 1
        }, {
          label: this.$root.$t('system_messagenotify_messagenotify_xitongtongzhi') ,
          value: 2
        }, {
          label: this.$root.$t('system_messagenotify_messagenotify_xiaoxitixing') ,
          value: 3
        }],

        NotifyTypeActive: 1,
        startX: 0,
        endX: 0,
        NotifyInfoLists: [],
        toDay: moment().format('YYYY-MM-DD'),
        UnreadIDs: [],
        UnreadLists: [],
        lists: [],
        model: {
          PageNo: 1,
          PageSize: 0,
          RecordCount: '',
        }
      }
    },
    computed: {
      UserID() {
        return this.profile.UserID
      },
      scrollbarObj() {
        return this.scrollbar ? {
          fade: this.scrollbarFade
        } : false
      },
      pullUpLoadObj() {
        return this.pullUpLoad ? {
          threshold: parseInt(this.pullUpLoadThreshold),
          txt: {
            more: this.pullUpLoadMoreTxt,
            noMore: this.pullUpLoadNoMoreTxt
          }
        } : false
      },
      pullDownRefreshObj() {
        return this.pullDownRefresh ? {
          threshold: parseInt(this.pullDownRefreshThreshold),
          stop: parseInt(this.pullDownRefreshStop)
        } : false
      },
      NotifyContentTypeTypes() {
        return this.$store.getters.categorys.types.NotifyContentType
      },
      flilterLists() {
        let __self = this;
        var results = _.filter(__self.UnreadLists, o => {
          let Flag = true;
          for (let i = 0; i < __self.UnreadIDs.length; i++) {
            if (o.NotifyID == __self.UnreadIDs[i]) {
              Flag = false
            }
          }
          return Flag
        })
        return results
      },
      flilterUnreadLists() {
        let __self = this;
        var results = _.filter(__self.UnreadLists, o => {
          let Flag = false;
          for (let i = 0; i < __self.UnreadIDs.length; i++) {
            if (o.NotifyID == __self.UnreadIDs[i]) {
              Flag = true
            }
          }
          return Flag
        })
        return results
      },
    },
    mounted() {
      let __self = this;
      __self.__init()
    },
    activated() {
      let __self = this;
    },
    methods: {
      scrollTo() {
        this.$refs.scroll.scrollTo(this.scrollToX, this.scrollToY, this.scrollToTime, ease[this.scrollToEasing]);
      },
      onPullingUp() {
        let __self = this;
        __self.model.PageNo++;
        __self.loadData(__self.NotifyTypeActive)
      },
      onPullingDown() {
        let __self = this;
        __self.model.PageNo = 1;
        __self.loadData(__self.NotifyTypeActive)

      },
      rebuildScroll() {
        this.$nextTick(() => {
          if (this.$refs.scroll) {
            this.$refs.scroll.destroy();
            this.$refs.scroll.initScroll();
          }
        })
      },
      isNewList(lists) {
        let __self = this;
        return _.find(JSON.parse($utils.localStorage.UnreadIDs), o => {
          return o == lists.NotifyID
        })
      },
      __init() {
        let __self = this;
        let data = {
          NotifyID: '',
          NotifyTitle: '',
          NotifyType: '',
          NotifyCode: '',
          FeatureCodes: 'Message',
          PageNo: __self.model.PageNo,
          PageSize: 15,
          OwnerID: '',
          RecordCount: 0,
          NotifyStatus: 1150
        }
        // __self.$api.admin.getNotifyLists(data).then(function (json) {
        //   if (json.isSucc) {
        //     $utils.localStorage.CreateTime = moment().format("YYYY-MM-DD HH:mm:ss");
        //     __self.NotifyInfoLists = json.result.entities;
        //     let UnreadLists = json.result.entities;
        //     let UnreadIDs = []
        //     json.result.entities.forEach(o => {
        //       UnreadIDs.push(o.NotifyID)
        //     })
        //     if ($utils.localStorage.UnreadIDs) {
        //       $utils.localStorage.UnreadIDs = JSON.stringify(JSON.parse($utils.localStorage.UnreadIDs).concat(
        //         UnreadIDs));
        //     } else {
        //       $utils.localStorage.UnreadIDs = JSON.stringify(UnreadIDs)
        //     }
        //     if ($utils.localStorage.UnreadLists) {
        //       $utils.localStorage.UnreadLists = JSON.stringify(JSON.parse($utils.localStorage.UnreadLists).concat(
        //         UnreadLists));
        //     } else {
        //       $utils.localStorage.UnreadLists = JSON.stringify(UnreadLists)
        //     }
        //     __self.UnreadIDs = JSON.parse($utils.localStorage.UnreadIDs);
        //     __self.UnreadLists = JSON.parse($utils.localStorage.UnreadLists);
        //     if (__self.$refs.scroll) {
        //       __self.$refs.scroll.forceUpdate();
        //     }
        //   }
        // });
      },
      ChangeNotifyType(value) {
        let __self = this;
        __self.NotifyTypeActive = value;
      },

      skip(index) {
        let __self = this;
        __self.UnreadIDs.splice(index, 1)
        $utils.localStorage.UnreadIDs = JSON.stringify(__self.UnreadIDs);
      },
      skipSystem(index, NotifyID) {
        let __self = this;
        let results = _.remove(__self.UnreadIDs, function (o) {
          return o != NotifyID
        })
        __self.UnreadIDs = _.cloneDeep(results)
        $utils.localStorage.UnreadIDs = JSON.stringify(__self.UnreadIDs);

      },
      loadData(NewValue) {
        let __self = this;
        let data = {
          NotifyID: '',
          NotifyTitle: '',
          NotifyType: '',
          NotifyCode: '',
          FeatureCodes: '',
          PageNo: __self.model.PageNo,
          PageSize: 15,
          RecordCount: 0,
          OwnerID: '',
          NotifyStatus: 1150
        }
        __self.rebuildScroll();
        if (NewValue === 1) {
          __self.__init();
        } else if (NewValue === 2) {
          let __self = this;
          data.FeatureCodes = 'system'
          data.OwnerID = __self.UserID
          // __self.$api.admin.getNotifyInfoList(data).then(function (json) {
          //   if (json.isSucc) {
          //     if (__self.model.PageNo == 1) {
          //       __self.lists = json.result.entities
          //     } else {
          //       __self.lists = _.concat(__self.lists, json.result.entities);
          //     }
          //     if (__self.$refs.scroll) {
          //       __self.$refs.scroll.forceUpdate();
          //     }
          //   }
          // })
        } else if (NewValue === 3) {
          data.FeatureCodes = 'remind'
          data.OwnerID = __self.UserID
          // __self.$api.admin.getNotifyInfoList(data).then(function (json) {
          //   if (json.isSucc) {
          //     if (__self.model.PageNo == 1) {
          //       __self.lists = json.result.entities
          //     } else {
          //       __self.lists = _.concat(__self.lists, json.result.entities);
          //     }
          //     if (__self.$refs.scroll) {
          //       __self.$refs.scroll.forceUpdate();
          //     }
          //   }
          // })
        }
      },
      deletes(index, NotifyID, reade) {
        let __self = this;
        if (reade != undefined) {
          if (reade == 'reade') {
            __self.flilterLists.splice(index, 1);
            __self.$forceUpdate();
          } else {
            __self.flilterUnreadLists.splice(index, 1);
            __self.$forceUpdate();
          }
        } else {
          __self.lists.splice(index, 1);
        }
        // __self.$api.admin.getNotifyInfoDelete(NotifyID).then(function (json) {
        //   if (json.isSucc) {
        //     return this.$root.$toast.success('删除成功', 'succ')
        //   }
        // })

      }
    },
    watch: {
      'NotifyTypeActive'(NewValue, OldValue) {
        let __self = this;
        if (NewValue) {
          __self.model.PageNo = 1;
          __self.loadData(NewValue)
        }
      },
      scrollbarObj: {
        handler() {
          this.rebuildScroll()
        },
        deep: true
      },
      pullDownRefreshObj: {
        handler() {
          this.rebuildScroll()
        },
        deep: true
      },
      pullUpLoadObj: {
        handler() {
          this.rebuildScroll()
        },
        deep: true
      },
      startY() {
        this.rebuildScroll()
      },
    },
    components: {
      navBar,
      notifyItem,
      Scroll
    }
  }

</script>
